export const topic = {
  label: 'Topic',
  key: 'action',
  icon: 'pulse',
  options: [{
    value: 'Variant Inventory Updated',
    label: 'Item Inventory Updated'
  }, {
    value: 'Permit Created',
    label: 'Permit Created'
  }, {
    value: 'Order Created',
    label: 'Order Created'
  }, {
    value: 'Order Closed',
    label: 'Order Closed'
  }, {
    value: 'Order Backordered',
    label: 'Order Backordered'
  }, {
    value: 'Shipment Closed',
    label: 'Shipment Closed'
  }, {
    value: 'Shipment Updated',
    label: 'Shipment Updated'
  }, {
    value: 'Order Canceled',
    label: 'Order Canceled'
  }, {
    value: 'Invoice Created',
    label: 'Invoice Created'
  }, {
    value: 'Credit Memo Created',
    label: 'Credit Memo Created'
  }, {
    value: 'RMA Return Approved',
    label: 'RMA Return Approved'
  }, {
    value: 'RMA Return Rejected',
    label: 'RMA Return Rejected'
  }, {
    value: 'RMA Completed',
    label: 'RMA Completed'
  }, {
    value: 'Identifiers Attribute Updated',
    label: 'Variant Identifier Attribute Updated'
  }, {
    value: 'Description Attribute Updated',
    label: 'Variant Description Attribute Updated'
  }, {
    value: 'General Attribute Updated',
    label: 'Variant General Attribute Updated'
  }, {
    value: 'Images Attribute Updated',
    label: 'Variant Image Attribute Updated'
  }, {
    value: 'Shipping Attribute Updated',
    label: 'Variant Shipping Attribute Updated'
  }, {
    value: 'Pricing Attribute Updated',
    label: 'Variant Pricing Attribute Updated'
  }, {
    value: 'Feed Request Approved',
    label: 'Feed Request Approved'
  }, {
    value: 'Misc Attribute Updated',
    label: 'Variant Misc Attribute Updated'
  }]
}
